'use client';

import { c as _c } from "react/compiler-runtime";
import { Bookmark } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useIsClient } from 'usehooks-ts';
import ViverseButton from '@/components/ViverseButton';
import { useAuthContext } from '@/context/AuthContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { cn } from '@/lib/utils';
type SaveButtonProps = {
  className?: string;
  iconClassName?: string;
  onSignedOutClick?: () => void;
};
export default function SaveButton(t0) {
  const $ = _c(20);
  const {
    className,
    iconClassName,
    onSignedOutClick
  } = t0;
  const t = useTranslations();
  const {
    isSignedIn
  } = useAuthContext();
  const {
    toggleSaveRoom,
    isSaveButtonEnabled,
    roomData
  } = useCheckEnterRoomContext();
  const isSaved = roomData.is_saved;
  const isClient = useIsClient();
  let t1;
  if ($[0] !== isSignedIn || $[1] !== onSignedOutClick || $[2] !== toggleSaveRoom) {
    t1 = () => {
      if (!isSignedIn && onSignedOutClick) {
        onSignedOutClick();
        return;
      }
      toggleSaveRoom();
    };
    $[0] = isSignedIn;
    $[1] = onSignedOutClick;
    $[2] = toggleSaveRoom;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("group flex min-w-fit gap-2", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !isSaveButtonEnabled || !isClient;
  let t4;
  if ($[6] !== isSaved || $[7] !== t) {
    t4 = isSaved ? t("worlds-landing.saved.aria.unsave") : t("worlds-landing.saved.aria.save");
    $[6] = isSaved;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isSaved && "fill-vive-brand-50 stroke-vive-brand-50";
  let t6;
  if ($[9] !== iconClassName || $[10] !== t5) {
    t6 = cn("group-hover:stroke-vive-brand-50 size-[18px] stroke-[#D5E2F2]", t5, iconClassName);
    $[9] = iconClassName;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Bookmark className={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleClick || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t7) {
    t8 = <ViverseButton className={t2} variant="filter" onClick={handleClick} disabled={t3} aria-label={t4}>{t7}</ViverseButton>;
    $[14] = handleClick;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}